import React, { useMemo } from "react";

import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import TimelineQueryCard from "../../charts/TimelineQueryCard";
import { signupsAndSubscriptionsQuery } from "../dashboard.queries";
import { buildActiveUsersTimeline } from "../dashboard.utils";

import type { JSX } from "react";

import type { GetSignupsAndSubscriptionsResponse } from "@/src/api/StatsAPI.types";

import type { ChartSeries, TimelineDatum } from "../../charts/charts.types";
import type {
  ActiveUsersSeriesKey,
  DashboardPeriodProps,
} from "../dashboard.types";

function buildTimeline(
  response: GetSignupsAndSubscriptionsResponse | undefined,
): TimelineDatum<ActiveUsersSeriesKey>[] {
  return buildActiveUsersTimeline(response?.data ?? []);
}

function ActiveUsersTimelineCard({
  period,
}: DashboardPeriodProps): JSX.Element {
  const { projectSlug } = useParams<{ projectSlug: string }>();
  const { t } = useTranslation("editor-analytics");

  const seriesList = useMemo(
    (): ChartSeries<ActiveUsersSeriesKey>[] => [
      {
        key: "activeUsers",
        label: t("dashboard.series.activeUsers"),
        color: "var(--chart-1)",
      },
    ],
    [t],
  );

  return (
    <TimelineQueryCard
      buildTimeline={buildTimeline}
      endDate={period.endDate}
      kind="stock"
      query={signupsAndSubscriptionsQuery(projectSlug, period)}
      seriesList={seriesList}
      startDate={period.startDate}
      title={t("dashboard.charts.activeUsers")}
    />
  );
}

export default ActiveUsersTimelineCard;
